import React, { useEffect } from 'react';
import { Container } from "reactstrap";
import { Navigate, Outlet } from "react-router-dom";
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import checkPermission from '../../../Components/Hooks/PermissionHook';
import { setBreadcrumb } from '../../../slices/auth/menu/reducer';

/**
 * Functional component for displaying company details.
 * @component
 */
function CompanyDetails() {
  const dispatch = useDispatch();
  const selectCompanyState = createSelector(state => state.MenuData, state => state.client);
  const company = useSelector(selectCompanyState);

  // useEffect(() => {
  //   dispatch(setBreadcrumb({pageTitle: 'Settings', title: [{name: 'Company Details', src: window.location.href}]}));
  // }, []);

  // if (checkPermission("companies", company._id, "companyDetailsView")) {
    return (
      <div className="table-responsive table-card mt-3 mb-1">
        <Container fluid>
          <Outlet />
        </Container>
      </div>
    )
  // } else {
  //   return (
  //     <Navigate to="/settings/personal-details" />
  //   )
  // }

}

export default CompanyDetails;